import {getPositionFromIndex} from './usePlayersReducer';
import {EditablePlayerSpot} from './EditablePlayerSpot';

const subs = Array.from({length: 4});

export function EditableSubstitutes({isEditable = true}) {
  return (
    <>
      {subs.map((_, index) => (
        <EditablePlayerSpot
          isSubstitute
          isEditable={isEditable}
          index={index}
          position={getPositionFromIndex(index as 0 | 1 | 2 | 3)}
          key={index}
          maxW="25%"
          h="max(5.5rem, 4em)"
        />
      ))}
    </>
  );
}
